import React, { useState, useEffect } from 'react';

import styles from './FirstPage.module.scss';
import sprite from './../../images/icons/sprite.svg';
import Language from './../../components/Language/Language';
import LogoWithName from './../../components/LogoWithName/LogoWithName';
import { Link } from 'react-router-dom';

const FirstPage = ({ onLoading }) => {
    let server = 'https://vitamin-art.ru:4444'

    let lang = localStorage.getItem('selectedLanguage')
    useEffect(() => {
        const newPromise = (ms = 0) => {
            return new Promise(r => setTimeout(() => r(), ms))
        }

        let firstPage = `${server}/api/first-page?locale=${lang}&populate=deep`;

        async function fetchData() {
            try {
                await newPromise();
                const response = await fetch(firstPage, {
                    headers: {
                        Authorization: `Bearer f66dbcdd40ea112c1922a33c00ef12399433cecaf44cc622f7ecb965b7462b1930e0bec5bb93f45ba485ada66eab5aaa548c1703eacf201a2a0bea3996cb0e746c94e9e316c737b4080eb53344edc4fe8d8bee794530d46926fdc72b75cb73a0cca89551386776de20138eea544f5458b22044468172b1a40f1a65a645e24998`
                    }
                });
                const data = await response.json();
                // firstpage data
                setData(data.data.attributes);
                setDescriptions(data.data.attributes.descriptions);
                // logo
                setLogo(data.data.attributes.logo);
                setLogoImg(data.data.attributes.logo.icon.data.attributes);
                setLogoWhiteImg(data.data.attributes.logo.iconWhite.data.attributes);
                // background
                setBackground(data.data.attributes.background.data.attributes);

                onLoading()
            } catch (e) {
                console.log(e);
            }
        }
        fetchData();
    }, []);

    // firstpage data
    const [data, setData] = useState({});
    const [descriptions, setDescriptions] = useState({});
    // logo
    const [logo, setLogo] = useState({});
    const [logoImg, setLogoImg] = useState({});
    const [logoWhiteImg, setLogoWhiteImg] = useState({});
    // background
    const [background, setBackground] = useState({});
    let backgroundStyle = {
        backgroundImage: `url(${background.url})`,
    }
    const descriptionsArray = []
    function multiData(array, data, key) {
        for (let i = 0; i < data.length; i++) {
            array.push(data[i][key])
        }
    }
    multiData(descriptionsArray, descriptions, 'paragraph')
    return (
        <section className={styles.firstPage} style={backgroundStyle}>
            <div className={styles.head}>
                <div>
                    <Link to="/home" aria-label="Главная страница" className={styles.logo}>
                        <LogoWithName
                            visibility='desctop'
                            url={logoImg.url}
                            urlWhite={logoWhiteImg.url}
                            alt={logoImg.alternativeText}
                            name={logo.name}
                        />
                    </Link>
                    <div className={styles.description}>
                        {descriptionsArray.map((item, index) => (
                            <p className={descriptions[index].removeIndentation === true ? '' : 'indent'} key={index}>{item}</p>
                        ))}
                    </div>
                </div>
                <h1>{data.title}</h1>
            </div>
            <div className={styles.foot}>
                <Link to='/home' className={styles.link} aria-label={data.buttonName}>
                    <Language ru={true} />
                </Link>
                <Link to='/home' className={styles.link} aria-label={data.buttonName}>
                    <Language en={true} />
                </Link>
                {/* <svg className="icon">
                        <use xlinkHref={`${sprite}#icon-arrow-right`}></use>
                    </svg> */}
            </div>
        </section>
    );
};

export default FirstPage;